export default "__VITE_ASSET__r8X3TbyR__"